import { get, post } from "../../axios-interceptor-setup/apiService";

const BASE_URL = "/auth";

export const specialAccessCheck = (userId) => {
  return get(
    `${BASE_URL}/special-access/${userId}`
  );
};